import { apiClient } from "./client";
import type {
  UserFolderWithCounts,
  UserFolderCreate,
  UserFolderUpdate,
  UserFolder,
  MessageResponse,
} from "@/types";

export async function listFolders(): Promise<UserFolderWithCounts[]> {
  const response = await apiClient.get<UserFolderWithCounts[]>("/folders");
  return response.data;
}

export async function createFolder(
  data: UserFolderCreate
): Promise<UserFolder> {
  const response = await apiClient.post<UserFolder>("/folders", data);
  return response.data;
}

export async function updateFolder(
  folderId: number,
  data: UserFolderUpdate
): Promise<UserFolder> {
  const response = await apiClient.patch<UserFolder>(
    `/folders/${folderId}`,
    data
  );
  return response.data;
}

export async function deleteFolder(
  folderId: number
): Promise<MessageResponse> {
  const response = await apiClient.delete<MessageResponse>(
    `/folders/${folderId}`
  );
  return response.data;
}
